import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerFormulario } from '@pages/style'
import { Row, Col, Typography, message, Button, Spin, Table } from 'antd'
import { HeaderPage, Input, Select } from '@components/atoms'
import { useRouter } from '@customHooks'
import { useForm } from 'react-hook-form'
import api from '@services/api'
import { SaveOutlined } from '@ant-design/icons'

export default function FormularioProdAlmoxarifado(): ReactElement {
  const {
    navigate,
    state,
    params: { id },
  } = useRouter<'id'>()
  const { control, reset, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)
  const { Column } = Table

  useEffect(() => {
    if (id && state) {
      reset({ ...(state as object) })
    }
  }, [state, id])

  const onSubmit = () => {
    handleSubmit(async (values) => {
      setLoading(true)
      id
        ? await api
            .put(`/produtoalmoxarifado/${id}`, values)
            .then(() => {
              setLoading(false)
              message.success('Produto atualizado com sucesso!')
              navigate('/vendas/produto_almoxarifado')
            })
            .catch(() => setLoading(false))
        : await api
            .post('/produtoalmoxarifado', values)
            .then(() => {
              setLoading(false)
              message.success('Produto cadastrado com sucesso!')
              navigate('/vendas/produto_almoxarifado')
            })
            .catch(() => setLoading(false))
    })()
  }

  return (
    <ContainerFormulario>
      <HeaderPage
        title={
          id
            ? 'Atualizar Produto por almoxarifado'
            : 'Novo Produto por almoxarifado'
        }
        onBack={() => navigate(-1)}
        extra={[
          <Button
            key='salvar'
            icon={<SaveOutlined />}
            type='primary'
            size='large'
            loading={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>,
        ]}
      />
      <form>
        <Spin spinning={loading}>
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <Typography.Title level={5}>Produto</Typography.Title>
              <Select
                control={control}
                name='ID_PRODUTO'
                placeholder='Produto'
                showSearch
              >
                <Select.Option value='Produto 1'>Produto 1</Select.Option>
                <Select.Option value='Produto 2'>Produto 2</Select.Option>
              </Select>
            </Col>
            <Col span={24} style={{ border: '1px solid #d9d9d9' }}>
              <Typography.Title level={4}>Almoxarifados</Typography.Title>
              <Row gutter={[12, 12]}>
                <Col span={12}>
                  <Typography.Title level={5}>Descrição</Typography.Title>
                  <Input
                    control={control}
                    name='DESCPRODUTO'
                    placeholder='Descrição'
                  />
                </Col>
                <Col span={3}>
                  <Typography.Title level={5}>Quantidade</Typography.Title>
                  <Input
                    control={control}
                    name='QTDEPRODUTO'
                    placeholder='Quantidade'
                  />
                </Col>
                <Col span={9}>
                  <Typography.Title level={5}>Localização</Typography.Title>
                  <Input
                    control={control}
                    name='LOCALIZACAO'
                    placeholder='Localização'
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
      </form>
    </ContainerFormulario>
  )
}
